import { SCUIContent } from '../../../atomic/organisms';
import { useTranslation } from 'react-i18next';
import { SCUIBreadCrumb } from '../../../atomic/molecules';
import React, { FC } from 'react';
import { Grid, Typography } from '@mui/material';
import { SCUILoading, SCUITabs } from '../../../atomic/atoms';
import { useRefundV2 } from './useRefundV2';
import { RefundV2PaymentInfoCard } from './components/RefundV2PaymentInfoCard/RefundV2PaymentInfoCard';
import { RefundV2OrderInfoCard } from './components/RefundV2OrderInfoCard/RefundV2OrderInfoCard';
import { RefundV2CustomerInfoCard } from './components/RefundV2CustomerInfoCard/RefundV2CustomerInfoCard';
import { RefundV2TabContent } from './components/RefundV2TabContent/RefundV2TabContent';
import { downloadExpenseBill, getCurrencySymbol, showSwalError } from './RefundV2.helpers';

export const RefundV2: FC<any> = (props: any) => {
    const { t } = useTranslation();
    const otherLink: string = import.meta.env.VITE_APPURL!;
    const {
        refundId,
        paymentListInfo,
        uniquePaymentListInfo,
        payBackListInfo,
        getRefundDetails,
        irsaliyeFaturaSeriNo,
        expanded,
        customerId,
        customerChoiceBankAccountId,
        shippingListId,
        tabIndex,
        orderId,
        returnId,
        loading,
        returnDatas,
        waitingRefundVisible,
        orderDate,
        documentHeaderOfInvoice,
        hasPaymentConversionCloseRefundRole,
        tabList,
        handleAccordionChange,
        onChangeTabs,
    } = useRefundV2(props);

    const currencySymbol = getCurrencySymbol(getRefundDetails?.entity?.currencyId);

    const handleExpenseBillClick = () => {
        downloadExpenseBill(getRefundDetails, t, (message) => showSwalError(message));
    };

    if (loading) {
        return (
            <SCUIContent>
                <SCUILoading />
            </SCUIContent>
        );
    }

    return (
        <SCUIContent>
            <Grid container direction="row" spacing={5}>
                <Grid
                    size={{
                        sm: 12,
                        md: 2,
                        lg: 2,
                        xl: 2,
                    }}
                >
                    <p className="headtxt" style={{ marginTop: '1rem' }}>
                        {t('refund.refundDetail')}
                    </p>
                </Grid>
                <Grid
                    size={{
                        sm: 12,
                        md: 10,
                        lg: 10,
                        xl: 10,
                    }}
                >
                    <SCUIBreadCrumb
                        components={[
                            { title: t('dashboard.returnRequests'), link: '/returnList' },
                            { title: t('refund.refund'), link: '/refund' },
                        ]}
                    />
                </Grid>
                <Grid
                    sx={{ paddingBottom: 1 }}
                    size={{
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    }}
                >
                    <Typography>
                        <strong>
                            {refundId} {t('refund.nthRefund')}
                        </strong>
                    </Typography>
                </Grid>
                <Grid
                    size={{
                        sm: 12,
                        md: 6,
                        lg: 4,
                        xl: 4,
                    }}
                >
                    <RefundV2PaymentInfoCard
                        paymentListInfo={paymentListInfo}
                        getRefundDetails={getRefundDetails}
                        payBackListInfo={payBackListInfo}
                        customerId={customerId}
                        orderId={orderId}
                        otherLink={otherLink}
                        onExpenseBillClick={handleExpenseBillClick}
                    />
                </Grid>
                <Grid
                    size={{
                        sm: 12,
                        md: 6,
                        lg: 4,
                        xl: 4,
                    }}
                >
                    <RefundV2OrderInfoCard
                        refundId={refundId}
                        documentHeaderOfInvoice={documentHeaderOfInvoice}
                        uniquePaymentListInfo={uniquePaymentListInfo}
                        expanded={expanded}
                        otherLink={otherLink}
                        onAccordionChange={handleAccordionChange}
                    />
                </Grid>
                <Grid
                    size={{
                        sm: 12,
                        md: 6,
                        lg: 4,
                        xl: 4,
                    }}
                >
                    <RefundV2CustomerInfoCard
                        customerId={customerId}
                        documentHeaderOfInvoice={documentHeaderOfInvoice}
                        otherLink={otherLink}
                    />
                </Grid>

                <Grid
                    sx={{ marginTop: 3 }}
                    size={{
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    }}
                >
                    <SCUITabs tabList={Object.values(tabList)} onChange={onChangeTabs} activeTabIndex={tabIndex} />

                    <Grid sx={{ padding: '16px', marginBottom: '48px' }}>
                        <RefundV2TabContent
                            tabIndex={tabIndex}
                            paymentListInfo={paymentListInfo}
                            payBackListInfo={payBackListInfo}
                            currencySymbol={currencySymbol}
                            refundId={refundId}
                            orderDate={orderDate}
                            shippingListId={shippingListId}
                            customerId={customerId}
                            irsaliyeFaturaSeriNo={irsaliyeFaturaSeriNo}
                            returnId={returnId}
                            waitingRefundVisible={waitingRefundVisible}
                            getRefundDetails={getRefundDetails}
                            returnDatas={returnDatas}
                            orderId={orderId}
                            customerChoiceBankAccountId={customerChoiceBankAccountId}
                            hasPaymentConversionCloseRefundRole={hasPaymentConversionCloseRefundRole}
                        />
                    </Grid>
                </Grid>
            </Grid>
        </SCUIContent>
    );
};
